import React from 'react';
import ZFlixSplashLogo from './ZFlixSplashLogo';

const BLOX_TAGLINE = 'Settle In. The Magic Awaits';

function ZFlixWordmark({ large, animateIn }) {
  const inClass = animateIn ? ' zflix-splash-lockup-wordmark--in' : '';
  const sizeClass = large ? ' zflix-splash-lockup-wordmark--lg' : ' zflix-splash-lockup-wordmark--sm';

  return (
    <span
      className={`zflix-splash-lockup-wordmark zflix-splash-lockup-wordmark--text${sizeClass}${inClass}`}
      aria-hidden
    >
      ZFLIX
    </span>
  );
}

/**
 * Vertical ZFLIX lockup: rounded-square icon, ZFLIX wordmark below.
 * @param {{ size?: 'large' | 'small'; className?: string; animateIn?: boolean; iconPopIn?: boolean; hideIcon?: boolean; showWordmark?: boolean; showTagline?: boolean }} props
 */
export default function ZFlixSplashLockup({
  size = 'large',
  className = '',
  animateIn = false,
  iconPopIn,
  hideIcon = false,
  showWordmark = true,
  showTagline = false,
}) {
  const popIcon = iconPopIn ?? animateIn;
  const large = size === 'large';
  const iconRenderPx = large ? 340 : 128;
  const gap = large ? 12 : 8;

  return (
    <div
      className={`zflix-splash-lockup zflix-splash-lockup--vertical${popIcon && !hideIcon ? ' zflix-splash-lockup--in' : ''} ${className}`.trim()}
      role="img"
      aria-label={showTagline ? `ZFLIX, ${BLOX_TAGLINE}` : 'ZFLIX'}
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap }}
    >
      {!hideIcon && (
        <ZFlixSplashLogo
          iconOnly
          iconPx={iconRenderPx}
          className="zflix-splash-lockup-icon"
        />
      )}
      {showWordmark && <ZFlixWordmark large={large} animateIn={animateIn} />}
      {showTagline && (
        <p className="zflix-splash-blox-tagline" aria-hidden>
          {BLOX_TAGLINE}
        </p>
      )}
    </div>
  );
}
